import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { useQueryParam } from '@mi-front/core';
import { Alert, AlertTitle, Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';

interface Props {
  platform: SocialPlatform;
}

/**
 * Component that displays a success alert when the connection result query parameter is 'success'.
 * This alert is shown after a successful platform connection to invite the user to configure the integration.
 */
export function ConnectionSuccessAlert({ platform }: Props) {
  const connectResult = useQueryParam('connect_result');

  if (connectResult !== 'success') {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Alert severity="success">
        <AlertTitle>
          <FormattedMessage
            id="socialExport.connectionSuccess.title"
            defaultMessage="Conexión exitosa con {name}"
            values={{ name: platform.name }}
          />
        </AlertTitle>
        <FormattedMessage
          id="socialExport.connectionSuccess.configureBelow"
          defaultMessage="Por favor, configura la integración a continuación."
        />
      </Alert>
    </Box>
  );
}
